export const enum RECORDING_STATUS {
    INITIAL,
    WAITING_FOR_START,
    RECORDING,
    STOPPING,
}
